import {
  Box,
  Container,
  SimpleGrid,
  Text,
  Link,
  Stack,
  VStack,
  IconButton,
} from "@chakra-ui/react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <Box bg="#28211d" color="#F5C7A9" py={10}>
      <Container maxW="6xl">
        <SimpleGrid columns={{ base: 1, md: 4 }} spacing={10}>
          {/* Office Section */}
          <VStack align="start">
            <Text fontSize="lg" fontWeight="bold">
              Office
            </Text>
            <Link
              href="https://www.google.com/maps/place/Qualiteeth+Dental+Care/@26.9018108,75.7366896,17z/data=!3m1!4b1!4m6!3m5!1s0x396db52aa8fff4cf:0xfd055fea55b4585d!8m2!3d26.901806!4d75.7392645!16s%2Fg%2F11l5vzlvgg?entry=ttu&g_ep=EgoyMDI1MDIxMS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              _hover={{ color: "#c49d84" }}
            >
              <Text>Akruti Apartments, Mahant Swami Marg</Text>
              <Text>Vaishali Nagar, Jaipur, Rajasthan</Text>
            </Link>

            <Text fontWeight="bold">
              <Link href="tel:+919256491206">(+91) 92564 91206</Link>
            </Text>
          </VStack>

          {/* Practice Section */}
          <VStack align="start">
            <Text fontSize="lg" fontWeight="bold">
              Practice
            </Text>
            <Link href="/#home" _hover={{ color: "#c49d84" }}>
              Home
            </Link>
            <Link href="/#about" _hover={{ color: "#c49d84" }}>
              About
            </Link>
            <Link href="/#service" _hover={{ color: "#c49d84" }}>
              Services
            </Link>
            <Link href="/#review" _hover={{ color: "#c49d84" }}>
              Reviews
            </Link>
            <Link href="/blog" _hover={{ color: "#c49d84" }}>
              Blogs
            </Link>
          </VStack>

          {/* Services Section */}
          <VStack align="start">
            <Text fontSize="lg" fontWeight="bold">
              Services
            </Text>
            <Link href="/dental-filling" _hover={{ color: "#c49d84" }}>
              Dental Fillings
            </Link>
            <Link href="/wisdom-teeth-removal" _hover={{ color: "#c49d84" }}>
              Wisdom Teeth Removal
            </Link>

            <Link href="/root-canal-treatment" _hover={{ color: "#c49d84" }}>
              Root Canal Treatment
            </Link>
            <Link href="/braces-and-aligners" _hover={{ color: "#c49d84" }}>
              Braces & Aligners
            </Link>

            <Link href="/dental-implants" _hover={{ color: "#c49d84" }}>
              Dental Implants
            </Link>
            <Link href="/dentures" _hover={{ color: "#c49d84" }}>
              Dentures
            </Link>
            <Link href="/bridges-and-crowns" _hover={{ color: "#c49d84" }}>
              Bridges & Crowns
            </Link>
            <Link href="/kids-dentistry" _hover={{ color: "#c49d84" }}>
              Kids Dentistry
            </Link>
            <Link href="/mouth-ulcers" _hover={{ color: "#c49d84" }}>
              Mouth Ulcers
            </Link>
          </VStack>

          {/* Review & Social Section */}
          <VStack align="start">
            <Text fontSize="lg" fontWeight="bold">
              Review Us
            </Text>
            <Link
              _hover={{ color: "#c49d84" }}
              href="https://search.google.com/local/writereview?placeid=ChIJz_T_qCq1bTkRXVi0VepfBf0"
            >
              Google
            </Link>
            <Text fontSize="lg" fontWeight="bold" mt={4}>
              Social
            </Text>
            <Stack direction="row" spacing={4}>
              <IconButton
                bg="#F5C7A9"
                borderRadius="full"
                as="a"
                href="https://www.facebook.com/share/14wSXppc43/?mibextid=wwXIfr"
                aria-label="Facebook"
                icon={<FaFacebook />}
              />
              <IconButton
                bg="#F5C7A9"
                borderRadius="full"
                as="a"
                href="https://www.instagram.com/qualiteeth_dental/"
                aria-label="Instagram"
                icon={<FaInstagram />}
              />
              <IconButton
                bg="#F5C7A9"
                borderRadius="full"
                as="a"
                href="https://www.linkedin.com/company/qualiteeth/"
                aria-label="LinkedIn"
                icon={<FaLinkedin />}
              />
            </Stack>
          </VStack>
        </SimpleGrid>

        {/* Bottom Footer Section */}
        <Box textAlign="center" mt={5}>
          <Text fontSize="sm">© Qualiteeth Dental 2025 </Text>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
